export enum RewardTypeEnum {
  BONUS_OFFER = 'bonus_offer',
  LEVEL_BOOSTER = 'level_booster',
  MISSION_BOOSTER = 'mission_booster',
  TOKEN_BOOSTER = 'token_booster',
  TOKENS = 'tokens',
  XP = 'xp',
}
